(() => {
  const BUS = {
    events: {
      request: 'lv:cart:request',     
      success: 'lv:cart:success',     
      error:   'lv:cart:error',       
      updated: 'lv:cart:updated',
      add:     'lv:cart:add',
    },
    endpoints: { 
      cart:   '/cart.js',
      add:    '/cart/add',
      change: '/cart/change',
      update: '/cart/update',
      clear:  '/cart/clear',
    }
  };

  const dispatch = (name, detail) => {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  };

  const isCartUrl = (url = '') => {
    if (!url) return false;
    return (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    );
  };

  const normalizeUrl = (input) => {
    try {
      if (typeof input === 'string') return input;
      if (input && typeof input.url === 'string') return input.url; // Request
    } catch (_) {}
    return '';
  };

  const safeJson = async (res) => {
    try { return await res.clone().json(); } catch (_) { return null; }
  };

  window.LV_CART = window.LV_CART || {};

  window.LV_CART.get = async () => {
    const res = await fetch(BUS.endpoints.cart, { credentials: 'same-origin' });
    //if (!res.ok) throw new Error('No se pudo leer /cart.js');
    return res.json();
  };

  window.LV_CART.change = async ({ line, quantity, properties }) => {
    const body = { line, quantity };
    if (properties) body.properties = properties;

    const res = await fetch(BUS.endpoints.change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    });
    //if (!res.ok) throw new Error('No se pudo cambiar la cantidad (cart/change.js)');
    return res.json();
  };

  window.LV_CART.update = async (updates) => {
    const res = await fetch(BUS.endpoints.update + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates }),
      credentials: 'same-origin'
    });
    //if (!res.ok) throw new Error('No se pudo actualizar el carrito (cart/update.js)');
    return res.json();
  };

  window.LV_CART.remove = async (line) => window.LV_CART.change({ line, quantity: 0 });

  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const url = normalizeUrl(args[0]);
    const isCart = isCartUrl(url);

    let payload = null;
    try {
      const opts = args[1] || {};
      if (opts && opts.body) payload = opts.body;
    } catch (_) {}

    if (isCart) {
      dispatch(BUS.events.request, { url, via: 'fetch', payload, at: Date.now() });
    }
    if (url.includes('/cart/add')) {
      dispatch(BUS.events.add, {
        url,
        via: 'fetch',
        payload,
        at: Date.now()
      });
    }
    const res = await originalFetch(...args);

    if (!isCart) return res;

    const data = await safeJson(res);
    const baseDetail = { url, via: 'fetch', status: res.status, ok: res.ok, response: data, at: Date.now() };

    if (res.ok) {
      dispatch(BUS.events.success, baseDetail);

      try {
        const cart = await window.LV_CART.get();
        dispatch(BUS.events.updated, { cart, source: baseDetail });
      } catch (err) {
      }
    } else {
      dispatch(BUS.events.error, baseDetail);
    }

    return res;
  };

  const XHR = window.XMLHttpRequest;
  const origOpen = XHR.prototype.open;
  const origSend = XHR.prototype.send;

  XHR.prototype.open = function(method, url, ...rest) {
    this.__lv_cart = { method, url: String(url || ''), isCart: isCartUrl(String(url || '')) };
    return origOpen.call(this, method, url, ...rest);
  };

  XHR.prototype.send = function(body) {
    if (this.__lv_cart?.isCart) {
      dispatch(BUS.events.request, { url: this.__lv_cart.url, via: 'xhr', payload: body || null, at: Date.now() });
      if (this.__lv_cart.url.includes('/cart/add')) {
        dispatch(BUS.events.add, {
          url: this.__lv_cart.url,
          via: 'xhr',
          payload: body || null,
          at: Date.now()
        });
      }
      this.addEventListener('load', async () => {
        const ok = this.status >= 200 && this.status < 300;
        let response = null;
        try { response = JSON.parse(this.responseText); } catch (_) {}

        const baseDetail = { url: this.__lv_cart.url, via: 'xhr', status: this.status, ok, response, at: Date.now() };

        if (ok) {
          dispatch(BUS.events.success, baseDetail);
          try {
            const cart = await window.LV_CART.get();
            dispatch(BUS.events.updated, { cart, source: baseDetail });
          } catch (_) {}
        } else {
          dispatch(BUS.events.error, baseDetail);
        }
      });
    }

    return origSend.call(this, body);
  };

  window.LV_CART.bus = BUS;
})();

(() => {
  const drawer  = document.querySelector('#lv-cart-drawer');
  const overlay = document.querySelector('#lv-cart-overlay');
  const bodyEl  = drawer?.querySelector('[data-cart-body]');
  const totalEl = drawer?.querySelector('[data-cart-total]');
  const noticeEl = drawer.querySelector('[data-cart-notice]');

  const showNotice = (msg, type = 'error') => {
    if (!noticeEl) return;
    noticeEl.textContent = msg || '';
    noticeEl.classList.toggle('is-error', type === 'error');
    noticeEl.classList.toggle('is-success', type === 'success');
    noticeEl.hidden = !msg;
  };

  const clearNotice = () => showNotice('', 'error');

  const pickErrorMessage = (detail) => {
    const r = detail?.response || {};
    return (
      r.description ||
      r.message ||
      (typeof r === 'string' ? r : '') ||
      'Ha ocurrido un error al actualizar el carrito.'
    );
  };

  const setLoading = (on) => {
    drawer.classList.toggle('is-loading', !!on);
  };

  let lvLangSwitchingUntil = 0;

  const setLangSwitching = (ms = 3000) => {
    lvLangSwitchingUntil = Date.now() + ms;
  };

  const isLangSwitching = () => Date.now() < lvLangSwitchingUntil;
  let lvLastAddAt = 0;

  document.addEventListener('lv:cart:add', () => {
    lvLastAddAt = Date.now();
  });

  const wasRecentAdd = (ms = 2000) => (Date.now() - lvLastAddAt) < ms;

  if (window.Weglot && typeof window.Weglot.on === 'function') {
    window.Weglot.on('languageChanged', () => setLangSwitching(3500));
  }

  const weglotTranslateNodes = (rootEl) => {
    try {
      if (!window.Weglot || !rootEl) return;

      if (typeof window.Weglot.addNodes === 'function') {
        window.Weglot.addNodes(rootEl);
        return;
      }

      if (typeof window.Weglot.dynamic === 'function') {
        window.Weglot.dynamic();
        return;
      }

      document.dispatchEvent(new Event('weglot:retranslate'));
    } catch (_) {}
  };

  if (!drawer || !overlay || !bodyEl || !totalEl || !window.LV_CART) return;

  const lockScroll = () => {
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.dataset.lvScrollY = String(scrollY);
    document.body.style.top = `-${scrollY}px`;
    document.documentElement.classList.add('lv-cart-scroll-lock');
  };

  const unlockScroll = () => {
    const y = parseInt(document.documentElement.dataset.lvScrollY || '0', 10) || 0;
    document.documentElement.classList.remove('lv-cart-scroll-lock');
    document.body.style.top = '';
    window.scrollTo(0, y);
  };

  const openDrawer = () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');

    overlay.hidden = false;
    overlay.classList.add('is-open');

    lockScroll();
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    overlay.classList.remove('is-open');
    overlay.hidden = true;

    unlockScroll();
  };

  const updateHeaderCartBubble = (cart) => {
    const headerLink = document.querySelector('#cart-icon-bubble');
    if (!headerLink || !cart) return;

    const iconEmpty = headerLink.querySelector('svg');

    let bubble = headerLink.querySelector('.cart-count-bubble');

    if (!cart.item_count || cart.item_count <= 0) {
      if (bubble) bubble.remove();
      headerLink.classList.add('is-empty');
      headerLink.classList.remove('is-not-empty');
      return;
    }

    headerLink.classList.remove('is-empty');
    headerLink.classList.add('is-not-empty');

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = `
        <span aria-hidden="true"></span>
        <span class="visually-hidden"></span>
      `;
      headerLink.appendChild(bubble);
    }

    const count = Math.min(cart.item_count, 99);
    const countEl = bubble.querySelector('span[aria-hidden="true"]');
    const srEl = bubble.querySelector('.visually-hidden');

    if (countEl) countEl.textContent = String(count);


    if (srEl) {
      srEl.textContent = cart.item_count === 1 ? '1 item' : `${cart.item_count} items`;
    }
  };


  const money = (cents, cart) => {
    return new Intl.NumberFormat(cart.locale || document.documentElement.lang, {
      style: 'currency',
      currency: cart.currency || 'EUR'
    }).format(cents / 100);
  };

  const render = (cart) => {
    const body = document.querySelector('[data-cart-body]');
    const total = document.querySelector('[data-cart-total]');
    const footer = document.querySelector('[data-cart-footer]');
    const icons = window.LV_CART_ICONS || {
      plus: '',
      minus: '',
      delete: '',
      deleteText: ''
    };

    if (!cart || !body ) return;

    if (!cart.item_count || cart.item_count <= 0) {
      if (footer) footer.hidden = true;

      if (total) total.textContent = '';

      const shopAllUrl = window.LV_ROUTES?.shopAll || '/collections/all';
      const strings = window.LV_STRINGS || {};
      const emptyButtonText = (strings.emptyText || '')
        .replace('{{ collection_name }}', ' ')
        .replace(/\s{2,}/g, ' ')
        .trim();

      body.innerHTML = `
        <div class="lv-cart-empty">
          <span>${strings.emptyTitle || 'Your cart is empty'}</span>
          <p>${emptyButtonText}</p>
          <a class="button button--primary" href="${shopAllUrl}">
            ${strings.shopAll || 'Shop all'}
          </a>
        </div>
      `;

      weglotTranslateNodes(body);
      return;
    }

    if (footer) footer.hidden = false;

    total.textContent = new Intl.NumberFormat(
      cart.locale || document.documentElement.lang,
      { style: 'currency', currency: cart.currency || 'EUR' }
    ).format(cart.total_price / 100);

    body.innerHTML = cart.items.map((item, index) => `
      <div class="lv-cart-line" data-line="${index + 1}">
        <img
          class="lv-cart-img"
          src="${item.image}"
          alt="${item.product_title}"
          loading="lazy"
          width="72"
          height="96"
        >

        <div class="lv-cart-info">
          <a
            href="${item.url}"
            class="lv-cart-title lv-cart-link"
            aria-label="${item.product_title}"
          >
            ${item.product_title}
          </a>


          <div class="lv-cart-price">
            ${new Intl.NumberFormat(
              cart.locale || document.documentElement.lang,
              { style: 'currency', currency: cart.currency || 'EUR' }
            ).format(item.final_line_price / 100)}
          </div>

          ${
            item.variant_title && item.variant_title !== 'Default Title'
              ? `<div class="lv-cart-variant">${item.variant_title}</div>`
              : ''
          }
          
          ${
            item.properties && Object.keys(item.properties).length
              ? `
                <dl class="lv-cart-properties">
                  ${Object.entries(item.properties)
                    .filter(([key, value]) => {
                      // fuera claves internas o vacías
                      if (!value) return false;
                      if (key.startsWith('_')) return false; // propiedades internas
                      if (value === '' || value === null) return false;
                      return true;
                    })
                    .map(([key, value]) => {
                      // si es array (a veces Shopify devuelve arrays)
                      const prettyValue = Array.isArray(value) ? value.join(', ') : value;

                      // si es link de upload, lo mostramos como link
                      const isUrl = typeof prettyValue === 'string' && /^https?:\/\//i.test(prettyValue);

                      return `
                        <div class="lv-cart-property">
                          <dt class="lv-cart-property-key">${key}:</dt>
                          <dd class="lv-cart-property-value">
                            ${isUrl ? `<a href="${prettyValue}" target="_blank" rel="noreferrer">Ver</a>` : `${prettyValue}`}
                          </dd>
                        </div>
                      `;
                    })
                    .join('')}
                </dl>
              `
              : ''
          }


          <div class="lv-cart-controls">
            <div>
              <button type="button" data-qty-minus aria-label="Restar">
                ${icons.minus}
              </button>

              <span
                class="lv-cart-qty"
                data-qty-value
              >
                ${item.quantity}
              </span>

              <button type="button" data-qty-plus aria-label="Sumar">
                ${icons.plus}
              </button>
            </div>

            <button
              type="button"
              data-remove
              class="lv-cart-remove-text"
              aria-label="Eliminar"
            >
              ${icons.deleteText}
            </button>
          </div>
        </div>
      </div>
    `).join('');
    weglotTranslateNodes(body);

  };

  bodyEl.addEventListener('click', async (e) => {
    const lineEl = e.target.closest('[data-line]');
    if (!lineEl) return;

    const line = Number(lineEl.getAttribute('data-line'));
    const qtyEl = lineEl.querySelector('[data-qty-value]');
    const currentQty = Number(qtyEl?.textContent || 0);

    try {
      if (e.target.closest('[data-qty-plus]')) {
        await window.LV_CART.change({ line, quantity: currentQty + 1 });
        return;
      }

      if (e.target.closest('[data-qty-minus]')) {
        await window.LV_CART.change({ line, quantity: Math.max(0, currentQty - 1) });
        return;
      }

      if (e.target.closest('[data-remove]')) {
        await window.LV_CART.remove(line);
        return;
      }
    } catch (err) {
      console.error('Cart action failed', err);
    }
  });

  bodyEl.addEventListener('change', async (e) => {
    if (!e.target.matches('[data-qty-input]')) return;
    const lineEl = e.target.closest('[data-line]');
    if (!lineEl) return;

    const line = Number(lineEl.getAttribute('data-line'));
    let qty = Number(e.target.value || 0);
    if (!Number.isFinite(qty) || qty < 0) qty = 0;

    try {
      await window.LV_CART.change({ line, quantity: qty });
    } catch (err) {
      console.error('Qty update failed', err);
    }
  });

  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-cart-open]')) {
      
      e.preventDefault();
      openDrawer();
      try { render(await window.LV_CART.get()); } catch (_) {}
    }
    if (e.target.closest('[data-cart-close]')) closeDrawer();
    if (e.target === overlay) closeDrawer();
  });

  document.addEventListener('lv:cart:updated', async (e) => {
    const cart = e.detail?.cart;
    if (!cart) return;

    await render(cart);
    weglotTranslateNodes(bodyEl);
    updateHeaderCartBubble(cart);
    if (isLangSwitching()) return;

    if (wasRecentAdd()) {
      openDrawer();
    }
  });

  document.addEventListener('lv:cart:request', () => {
    clearNotice();
    setLoading(true);
  });

  document.addEventListener('lv:cart:success', () => {
    setLoading(false);
  });

  document.addEventListener('lv:cart:error', (e) => {
    setLoading(false);
    const msg = pickErrorMessage(e.detail);
    showNotice(msg, 'error');
    openDrawer();
    weglotTranslateNodes(noticeEl);
  });


  function escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }
  window.LV_CART.get().then(render).catch(()=>{});
  
})();

(function () {
  const DEBOUNCE_MS = 650;

  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  async function postCartNote(note) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note })
    });
    if (!res.ok) throw new Error('Cart note update failed');
    return res.json();
  }

  function initCartNotes(root) {
    const textarea = root.querySelector('[data-cart-note]');
    if (!textarea || textarea.dataset.lvBound === '1') return;

    textarea.dataset.lvBound = '1';

    let lastSavedNote = null;
    let inFlightPromise = null;

    const saveNow = async (reason) => {
      const note = textarea.value || '';
      if (lastSavedNote !== null && note === lastSavedNote) {
        //console.log('[LV Cart Note] Skip save (no changes). Reason:', reason);
        return;
      }

      //console.log('[LV Cart Note] Saving note now. Reason:', reason, { note });

      inFlightPromise = (async () => {
        const cart = await postCartNote(note);
        lastSavedNote = note;
        //console.log('[LV Cart Note] Saved ok.', { note, cartNote: cart.note });
        return cart;
      })();

      try {
        await inFlightPromise;
      } catch (e) {
        console.log('[LV Cart Note] Save failed:', e);
      } finally {
        inFlightPromise = null;
      }
    };

    const saveDebounced = debounce(() => saveNow('debounce'), DEBOUNCE_MS);

    (async () => {
      try {
        const cart = await getCart();
        const existing = cart && typeof cart.note === 'string' ? cart.note : '';
        textarea.value = existing || '';
        lastSavedNote = textarea.value;
        //console.log('[LV Cart Note] Loaded cart note from /cart.js:', { note: existing });
      } catch (e) {
        //console.log('[LV Cart Note] Could not load /cart.js:', e);
      }
    })();

    textarea.addEventListener('input', () => {
      //console.log('[LV Cart Note] input -> debounce start', { value: textarea.value });
      saveDebounced();
    });

    textarea.addEventListener('blur', () => {
      saveNow('blur');
    });

    const checkoutBtn = root.querySelector('.lv-cart-checkout');
    if (checkoutBtn && checkoutBtn.dataset.lvBoundCheckout !== '1') {
      checkoutBtn.dataset.lvBoundCheckout = '1';

      checkoutBtn.addEventListener('click', async (e) => {
        const note = textarea.value || '';
        if (lastSavedNote !== null && note === lastSavedNote) {
          //console.log('[LV Cart Note] Checkout click -> no note changes, continue.');
          return;
        }

        e.preventDefault();

        //console.log('[LV Cart Note] Checkout click -> forcing save before navigation.');

        if (inFlightPromise) {
          try { await inFlightPromise; } catch (_) {}
        } else {
          await saveNow('checkout_click');
        }

        window.location.href = checkoutBtn.getAttribute('href');
      }, true);
    }
  }

  function boot() {
    const drawer = document.querySelector('#lv-cart-drawer');
    if (!drawer) return;

    initCartNotes(drawer);

    const mo = new MutationObserver(() => initCartNotes(drawer));
    mo.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();